export enum BorrowerRole {
  Borrower = 'Borrower',
  CoBorrower = 'Coborrower',
}
